<template>
  
<customdialog v-model="val.dialogShow" title="Kişi arama aaaaa">

            <!-- Begin Arama Kriterleri ******************************************************************************-->              
            <div class="layout">
                <v-text-field v-model="prm.adSoyad" label="Isim Ara" ></v-text-field>
                <btnprogres v-model="status.loading" title="Ara" @click="Ara()"></btnprogres>
            </div>
            <!-- End Arama Kriterleri  *******************************************************************************-->
            
            <!-- Begin Data Table ************************************************************************************-->
            <v-data-table
                :headers="tableheaders"
                :items="tabledata"
                :loading="status.loading"
                hide-actions
                class="elevation-1"
            >
                
                <template slot="items" slot-scope="props">
                  <tr @click="Sec(props.item)">
                    
                    <td>{{ props.item.adSoyad }}</td>
                    <td>{{ props.item.tcKimlikNo }}</td>
                    <td>{{ props.item.eMail }}</td>
                    <td>{{ props.item.gsm }}</td>



                  </tr>
                </template>
            </v-data-table>
            <!-- End Data Table *************************************************************************************** -->
</customdialog>

</template>


<script>
  import tool from '../tools'
  import arksnackbar from '@/components/app/coper/comp/arksnackbar.vue'
  import btnprogres from '@/components/app/coper/comp/btnprogres.vue'
  import customdialog from "@/components/app/coper/comp/customdialog.vue";



  export default {
    components: {
      arksnackbar,
      btnprogres,
      customdialog,

    },

    props: ['value'],
    computed: {
      val: {
        get: function () {

            //console.log(this.value);
            //this.setDialogShow(this.value.dialogShow);
            return this.value;
        },
        set: function (newValue) {
            //console.log(newValue);
            //this.setDialogShow(newValue.dialogShow);
            this.$emit('input', newValue )
        },
      },
    },

    data () {
      return {
        prm:{
        },
        dialogShow: false,  
        tableheaders: [
          { text: 'İsim', value: 'adSoyad' },
          { text: 'tcKimlikNo', value: 'tcKimlikNo' },
          { text: 'eMail', value: 'eMail' },
          { text: 'gsm', value: 'gsm' },
        ],
        tabledata: [],
        status : tool.NewSatatus(),
        
      }
    },

    
    methods: {
      Ara:Ara,
      Sec:Sec,
      
    }
  }
  

  function Sec(v) {
    Object.assign(this.value.adres,v);
    this.value.dialogShow=false;
  }


  function Ara() {
        this.tabledata=[];

        if (this.status.loading===false)
        {              
          this.status.loading=true;
          setTimeout(() => {
            tool.http_post(this,'TblAdresAra',this.prm).then((response) => {
            this.tabledata = response.body;
            this.status.loading=false;

          }, (response) => {
            this.status = tool.responseToStatus(response);
          })

          }, 500)
        }

    }


</script>
